import axios from '../api/axios';
import useAuth from './useAuth';

const useLogout = () => {
  const { setAuth } = useAuth();

  const logout = async () => {
    setAuth({
      accessToken: '',
      roles: [],
      user: undefined,
      aiTrainingComplete: undefined,
    });
    try {
      await axios('/logout', {
        withCredentials: true,
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };

  return logout;
};

export default useLogout;
